import { render, staticRenderFns } from "./LoyaltyStampsSettings.vue?vue&type=template&id=1a601d10&scoped=true&lang=pug&"
import script from "./LoyaltyStampsSettings.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampsSettings.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyStampsSettings.vue?vue&type=style&index=0&id=1a601d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a601d10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VForm,VIcon,VImg,VProgressCircular,VRadio,VRadioGroup,VResponsive,VRow,VSpacer,VTextField})
